"use client"

import React, {useState, useEffect} from "react";
import ReactECharts from "echarts-for-react";

interface Props {
  data?: any[];
  direction: "up" | "down";
  isBrand?: boolean;
}

export const TrendsBarChart: React.FC<Props> = ({data = [], direction, isBrand = false}) => {
  const [dataset, setDataset] = useState<any[]>([]);

  useEffect(() => {
    const updatedDataset: [string, number][] = [];

    if (data) for (let key in data) {
      if (data[key].trend == direction)
        updatedDataset.push([key, data[key].value]);
    }

    const sortedData = updatedDataset.sort((a, b) => b[1] - a[1]).slice(0, 5);
    setDataset(sortedData);
  }, [data]);

  const dataLen = dataset.length;

  return (
    <>
      <ReactECharts
        style={{
          height: `${dataLen *
            (dataLen < 2 ? 130 : dataLen < 4 ? 90 : dataLen < 5 ? 60 : 50)
            }px`,
        }}
        option={{
          dataset: [
            {
              dimensions: ["category", "score"],
              source: dataset,
            },
            {
              transform: {
                type: "sort",
                config: {dimension: "score", order: "asc"},
              },
            },
          ],
          tooltip: {
            trigger: "axis",
          },
          grid: {
            left: "3%",
            // right: "28%",
            bottom: "3%",
            containLabel: true,
          },
          toolbox: {
            feature: {
              saveAsImage: {},
            },
          },

          xAxis: {
            type: "value",
          },
          yAxis: {type: "category", axisLabel: {interval: 0, rotate: 0}},
          series: {
            ...(direction == "down"
              ? {name: "% Penurunan"}
              : {name: "% Peningkatan"}),
            type: "bar",
            ...(direction == "down"
              ? {color: "#F84F07"}
              : {color: "#07B0F8"}),
            encode: {x: "score", y: "name"},
            datasetIndex: 1,
          },
        }}
      />

      {dataset.length < 1 && (
        <p className="text-black text-base py-2">
          Tidak ada {isBrand ? "merek" : "topik umum"} yang mengalami{" "}
          {direction == "down" ? "penurunan" : "kenaikan"}.
        </p>
      )}
    </>
  );
}
